import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from './http-base.service';
import { CompanyDomainCreateDto, CompanyDomainListDto, CompanyDomainUpdateDto } from '../dtos/company.types';

@Injectable({
    providedIn: 'root'
})
export class CompanyDomainService extends HttpBaseService {
    private readonly baseEndpoint = 'api/CompanyDomains';

    /**
     * Get all company domains
     * @return Observable containing a list of company domains
     */
    getAllCompanyDomains(): Observable<CompanyDomainListDto[]> {
        return this.get<CompanyDomainListDto[]>(this.baseEndpoint);
    }

    /**
     * Get company domain by ID
     * @param domainId ID of the company domain to retrieve
     * @returns Observable containing the company domain details
     */
    getCompanyDomainById(domainId: string): Observable<CompanyDomainListDto> {
        return this.get<CompanyDomainListDto>(`${this.baseEndpoint}/${domainId}`);
    }

    /**
     * Create a new company domain
     * @returns Observable containing the created domain's ID
     */
    createCompanyDomain(domain: CompanyDomainCreateDto): Observable<{ id: string }> {
        return this.post<{ id: string }>(this.baseEndpoint, domain);
    }

    /**
     * Update an existing company domain
     * @param domain Domain data to update
     * @returns Observable indicating completion of the update operation
     */
    updateCompanyDomain(domain: CompanyDomainUpdateDto): Observable<void> {
        return this.put<void>(this.baseEndpoint, domain);
    }

    /**
     * Get company domain for update
     * @param domainId  ID of the domain to update
     * @returns Observable containing the company domain update DTO
     */
    getCompanyDomainForUpdate(domainId: string): Observable<CompanyDomainUpdateDto> {
        return this.get<CompanyDomainUpdateDto>(`${this.baseEndpoint}/${domainId}/update`);
    }

    /**
     * Delete a company domain
     * @param domainId ID of the domain to delete
     * @returns Observable indicating completion of the delete operation
     */
    deleteCompanyDomain(domainId: string): Observable<void> {
        return this.delete<void>(`${this.baseEndpoint}/${domainId}`);
    }
}